import { render, staticRenderFns } from "./UnreturnedSkis.vue?vue&type=template&id=90be8ad4&scoped=true"
import script from "./UnreturnedSkis.vue?vue&type=script&lang=js"
export * from "./UnreturnedSkis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90be8ad4",
  null
  
)

export default component.exports